import React, { useState, useEffect } from 'react';
import api from '../config/api';
import PageNavbar from './PageNavbar';
import './Desserts.css';

const CupCakes = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({ name: '', description: '', default_price: '', active: true });

  const fetchItems = async () => {
    try {
      const response = await api.get('/users/cup-cakes/list');
      setItems(response.data.cup_cakes || []);
    } catch (error) {
      console.error('Error fetching cup cakes:', error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const resetForm = () => {
    setFormData({ name: '', description: '', default_price: '', active: true });
    setEditing(null);
    setShowForm(false);
  };

  const handleEdit = (item) => {
    setEditing(item);
    setFormData({
      name: item.name || '',
      description: item.description || '',
      default_price: item.default_price != null ? String(item.default_price) : '',
      active: item.active !== false
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: formData.name.trim(),
        description: formData.description.trim() || undefined,
        default_price: formData.default_price.trim() !== '' ? formData.default_price : null,
        active: formData.active
      };
      if (editing) {
        await api.put(`/users/cup-cakes/${editing.id}`, payload);
        alert('Cup cake updated successfully');
      } else {
        await api.post('/users/cup-cakes', payload);
        alert('Cup cake added. Order creators can select it when adding Cup Cakes to an order.');
      }
      resetForm();
      fetchItems();
    } catch (error) {
      alert(error.response?.data?.error || `Error ${editing ? 'updating' : 'adding'} cup cake`);
    }
  };

  const handleToggleActive = async (item) => {
    if (!window.confirm(`${item.active ? 'Deactivate' : 'Activate'} "${item.name}"?`)) return;
    try {
      await api.put(`/users/cup-cakes/${item.id}`, { active: !item.active });
      fetchItems();
    } catch (error) {
      alert(error.response?.data?.error || 'Failed to update');
    }
  };

  return (
    <div className="desserts-page">
      <PageNavbar />
      <div className="container">
        <div className="desserts-header">
          <h1>Cup Cakes</h1>
          <button className="btn btn-primary" onClick={() => showForm ? resetForm() : setShowForm(true)}>
            {showForm ? 'Cancel' : 'Add Cup Cake'}
          </button>
        </div>
        {showForm && (
          <div className="card">
            <h2>{editing ? 'Edit Cup Cake' : 'Add New Cup Cake'}</h2>
            <p className="desserts-hint">Order creators will select from this list when adding &quot;Cup Cakes&quot; to an order.</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input type="text" className="form-control" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required placeholder="e.g. Chocolate Cup Cake" />
              </div>
              <div className="form-group">
                <label>Description (optional)</label>
                <input type="text" className="form-control" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} placeholder="Short description" />
              </div>
              <div className="form-group">
                <label>Default price (₹)</label>
                <input type="number" step="0.01" min="0" className="form-control" value={formData.default_price} onChange={(e) => setFormData({ ...formData, default_price: e.target.value })} placeholder="e.g. 50" />
              </div>
              {editing && (
                <div className="form-group">
                  <label><input type="checkbox" checked={formData.active} onChange={(e) => setFormData({ ...formData, active: e.target.checked })} />{' '}Active</label>
                </div>
              )}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" className="btn btn-primary">{editing ? 'Update' : 'Add Cup Cake'}</button>
                {editing && <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancel</button>}
              </div>
            </form>
          </div>
        )}
        {loading ? <div className="loading">Loading...</div> : (
          <div className="card">
            <h2>All Cup Cakes</h2>
            <p className="desserts-hint">Active items appear in the order form.</p>
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr><th>Name</th><th>Description</th><th>Default price (₹)</th><th>Status</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr><td colSpan="5" className="no-data">No cup cakes yet. Click &quot;Add Cup Cake&quot;.</td></tr>
                  ) : items.map((d) => (
                    <tr key={d.id} className={d.active ? '' : 'dessert-inactive'}>
                      <td><strong>{d.name}</strong></td>
                      <td>{d.description || '-'}</td>
                      <td>{d.default_price != null ? `₹${parseFloat(d.default_price).toFixed(2)}` : '-'}</td>
                      <td><span className={`status-badge ${d.active ? 'status-active' : 'status-inactive'}`}>{d.active ? 'Active' : 'Inactive'}</span></td>
                      <td>
                        <button className="btn btn-sm btn-primary" onClick={() => handleEdit(d)} style={{ padding: '5px 12px', fontSize: '14px', marginRight: '8px' }}>Edit</button>
                        <button className={`btn btn-sm ${d.active ? 'btn-secondary' : 'btn-success'}`} onClick={() => handleToggleActive(d)} style={{ padding: '5px 12px', fontSize: '14px' }}>{d.active ? 'Deactivate' : 'Activate'}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CupCakes;
